import { legenditemHeight, legendWidth, height, width, setUpChart, selectSvg } from '~/app/d3charts/utils/common'
import { buildYScale, buildXScaleBand } from '~/app/d3charts/utils/chart_scales'
import { buildXAxis, buildYAxis, yAxisUnit } from '~/app/d3charts/utils/chart_axis'

import { darkColor, color } from '~/app/d3charts/bar_chart/colors'

import 'd3-scale'
import d3Tip from 'd3-tip'

const tooltipContainerCss = 'd3-tooltip bg-dark rounded-1 p-3'
const innerTooltipCss = 'text-neutral-000 label-1'
const roundedCornersDegree = 12

export function build(dataSets, containerSelector, xAxis, yAxis) {
  setUpChart(containerSelector, 0)

  // Svg container
  const svg = selectSvg(containerSelector)

  const chart = svg.select('.chart')

  // Header - Legend
  const legend = buildLegend(svg, dataSets)

  legend
    .append('circle')
    .attr('r', 7)
    .attr('stroke-width', 3)
    .attr('stroke', darkColor)
    .attr('fill', function (data, index) {
      return color(index)
    })

  legend
    .append('text')
    .attr('x', 15)
    .attr('y', 7)
    .attr('font-size', '12')
    .text(function (data) {
      return data.replaceAll('_', ' ')
    })

  // Chart - Tooltip
  const tooltip = d3Tip()
    .attr('class', tooltipContainerCss)
    .offset([-10, 0])
    .html(function (event, data) {
      return `<span class='${innerTooltipCss}'> ${data.value} ${yAxisUnit}</span>`
    })

  // Chart - X axis and grid
  const xScale = buildXScaleBand(xAxis, width(), 0.9)
  buildXAxis(chart, height, xScale)

  // Chart - Y axis
  const yScale = buildYScale(yAxis, height)
  buildYAxis(chart, height, yScale, yAxisUnit)

  // Chart - Bars
  dataSets.forEach((dataSet, index) => {
    buildChart(dataSet, index)
  })

  function buildChart(dataSet, index) {
    chart
      .selectAll('.bar')
      .data(dataSet.data, data => data.id)
      .enter()
      .append('rect')
      .attr('fill', color(index))
      .attr('stroke', darkColor)
      .attr('width', xScale.bandwidth())
      .attr('height', data => height - yScale(data.value))
      .attr('rx', roundedCornersDegree) // make bar borders rounded
      .attr('x', data => xScale(data.year))
      .attr('y', data => yScale(data.value))
      .call(tooltip)
      .on('mouseover', tooltip.show)
      .on('mouseout', tooltip.hide)
  }
}

function buildLegend(svg, dataSets) {
  const legendGroup = svg.select('.legend-group')
  const legendItems = dataSets.map(dataSet => dataSet.name)
  const legendItemPerRow = 2
  const itemWidth = legendWidth / legendItemPerRow

  const legend = legendGroup
    .selectAll('.legend')
    .data(legendItems)
    .enter()
    .append('g')
    .attr('transform', function (d, index) {
      return `translate(${(index % legendItemPerRow) * itemWidth}, ${Math.floor(index / legendItemPerRow) * legenditemHeight})`
    })
    .attr('class', 'legend')

  return legend
}
